/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ActionCodeValue } from './actionCodeValue';
import { ErrorValue } from './errorValue';
import { ReportCodeValue } from './reportCodeValue';
import { SystemAttributesValue } from './systemAttributesValue';

export class SysAttrWrapper {
  sysAttrMap?: { [key: string]: any; };
  actionCodeMap?: { [key: string]: ActionCodeValue; };
  errCdMap?: { [key: string]: ErrorValue; };
  lkupMap?: { [key: string]: string; };
  reportMap?: { [key: string]: ReportCodeValue; };
  systemAttributesValue?: SystemAttributesValue;
}
